<div
  class="subheader subheader-transparent d-flex align-items-center d-md-block"
  id="kt_subheader"
  >
  <!-- *ngIf="breadcrumb?.text" -->
  <div
    class="container-fluid d-flex align-items-center h-100 justify-content-between flex-wrap flex-sm-nowrap"
  >
    <!--begin::Info-->
    <div class="d-flex align-items-center mr-1">
      <!--begin::Page Heading-->
      <div class="d-flex align-items-baseline flex-wrap mr-5">
        <!--begin::Breadcrumb-->
        <ul
          class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold my-2 p-0"
        >
         <li class="breadcrumb-item text-muted" *ngIf="breadcrumb?.title">
            <a class="text-muted">{{ breadcrumb?.title }}</a>
          </li>
          <li
            class="breadcrumb-item"
            [ngClass]="{
              active: !breadcrumb?.subtext,
              'text-muted': breadcrumb?.subtext
            }"
          >
            <span
              *ngIf="!breadcrumb?.subtext; else linkBreadCrumb"
              [ngClass]="{
                'font-size-h3': !breadcrumb?.subtext,
                'text-muted': breadcrumb?.subtext
              }"
              >{{ breadcrumb?.text }}</span
            >
            <ng-template #linkBreadCrumb>
              <a [routerLink]="breadcrumb?.link">{{ breadcrumb?.text }}</a>
            </ng-template>
          </li>
          <li
            *ngIf="breadcrumb?.subtext"
            class="breadcrumb-item"
            [class.active]="breadcrumb?.subtext"
          >
            <span class="font-size-h3">{{ breadcrumb?.subtext }}</span>
          </li> 
        </ul>
        <!--end::Breadcrumb-->
      </div>
      <!--end::Page Heading-->
    </div>
    <!--end::Info-->
  </div>
</div>
